import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
// import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'lodash';
import cx from 'classnames';
import { MyPATLink } from '../../common';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Edit from '@material-ui/icons/Edit';
import { setCourseData } from "../actions/courseSetData"
import { styles } from '../styling/component/landing_pages'
import ResponseBasedACL from '../../acl/components/ResponseBasedACL';

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { getDateStatus, getGoals, getDate, getNoOfMonths, getBatches, getPercentage } from "../components/CourseDetail/commonFunction"
import MyPatCircleProgress from "../../common/MyPatCircleProgress";
import MyPatSliderProgress from "../../common/MyPatSliderProgress";

import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

const classis = {
  percentage: {
    fontSize: "15px"
  }
}
interface WithContentProps extends WithStyles<typeof styles> {
  isDetailDrawerOpen: boolean;
  onViewDetailsClick: Function;
  setCourseData: Function;
  filterGoals: any,
  courseListingData: any,
  isArchived: Boolean;
}

interface WithContentStates {
  data: any;
  sortBy: any;
  anchorEl: any;
  completed: number;
}

class LandingPage extends Component<WithContentProps, WithContentStates>{
  constructor(props: WithContentProps) {
    super(props);
    this.state = {
      data: [],
      sortBy: [],
      anchorEl: false,
      completed: 0
    }

    this.setCourseDetails = this.setCourseDetails.bind(this)
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  componentWillMount() {
    var self = this;
  }

  setCourseDetails(data: any) {
    this.props.setCourseData(data)
  }

  progress = () => {
    const { completed } = this.state;
    this.setState({ completed: completed >= 100 ? 0 : completed + 10 });
  };

  render() {
    const { classes, onViewDetailsClick, filterGoals, courseListingData, isArchived } = this.props;
    var goalHeading = '';
    var self = this;
    let colorArr: { [index: string]: string } = {};
    colorArr = {
      "PUBLISHED0": "#2196F3",
      "LIVE0": "#7DCA36",
      "PAST0": "#C6C6C6",
      "DRAFT0": "#F35821",
      "DRAFT1": "#F39221",
      "DRAFT2": "#F0E617",
      "ARCHIVE": "#C6C6C6"
    }

    var ListDiv = courseListingData.map(function (value: any, index: any) {
      var getStatus: any = getDateStatus(value.startDate, value.expiryDate, value.status, value.draftCompletionPercentage) || "DRAFT0"
      let percentage = getPercentage(value.startDate, value.expiryDate);
      let statusFlag = getStatus.substring(0, getStatus.length - 1)
      let _color = isArchived ? colorArr["ARCHIVE"] : colorArr[getStatus.toString()];
      let allowedTo: number = value.aclMetaData.allowedTo.length || 0;

      if (value.draftCompletionPercentage) {
        if (value.draftCompletionPercentage == 0) {
          var draftPercentage = value.draftCompletionPercentage + 0;
        }
        else if (value.draftCompletionPercentage > 100) {
          var draftPercentage: any = 100;
        }
        else {
          var draftPercentage = value.draftCompletionPercentage
        }
      }
      return (value.name && value.goals) ? (
        <div key={index}>
          {(filterGoals || []).join(",")}
          <Paper elevation={1} style={{ marginBottom: 10 }}>
            <ListItem>
              <Grid item xs={1}>
                {
                  value.courseIcon ? <img style={{width:"80px",height:"80px",borderRadius:"50%",border:"5px solid slategray"}} src={value.courseIcon} alt="course_img"></img> :
                  <MyPatCircleProgress percentage={draftPercentage} color={_color} innerText={(value.name).toLocaleUpperCase().substring(0, 1)} />
                }
                {!isArchived ? (statusFlag != "DRAFT" ?
                  <Grid container alignItems="center" justify="center" className={classes.textBar}>{statusFlag}

                  </Grid>
                  : <Grid container alignItems="center" justify="center" className={classes.textBar}>{value.draftCompletionPercentage + "% "}{<span style={{ fontSize: 8 }}> &nbsp;{"Draft Progress"}</span>}</Grid>)

                  : (
                    <Grid container alignItems="center" justify="center" className={classes.textBar}>{"Archived"}</Grid>
                  )
                }
              </Grid>

              {isArchived ? (
                <Grid item xs={12}  >
                  <Grid container className={classes.leftDisplay}>
                    <Grid item xs={12}>
                      <Typography variant="body1" className={cx(classes.textEllipsis)}>{value.name}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" className={cx(classes.textEllipsis)}>{getGoals(value.goals).join(", ")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" className={classes.subTitle}><b>Course Duration : </b>{getDate(value.startDate, value.expiryDate)}</Typography>
                    </Grid>
                    {value.setting.batches.length > 0 ?
                      <Grid item xs={12}>
                        <Typography variant="body2" className={classes.subTitle}><b> Batches: {getBatches(value.setting).join(', ')} </b></Typography>
                      </Grid> : ''}
                  </Grid>
                </Grid>
              )
                : (
                  <MyPATLink onClick={() => self.setCourseDetails(value)} className={classes.courseCardContainer} to={'/course/detail/' + value._id} target="_blank">

                    <Grid item xs={12}  >
                      <Grid container className={classes.leftDisplay}>
                        <Grid item xs={12}>
                          <Typography variant="body1" className={cx(classes.textEllipsis)}>{value.name}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body2" className={cx(classes.textEllipsis)}>{getGoals(value.goals).join(", ")}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body2" className={classes.subTitle}><b>Course Duration : </b>{getDate(value.startDate, value.expiryDate)}</Typography>
                        </Grid>
                        {value.setting.batches.length > 0 ?
                          <Grid item xs={12}>
                            <Typography variant="body2" className={classes.subTitle}><b> Batches: {getBatches(value.setting).join(', ')} </b></Typography>
                          </Grid> : ''}
                      </Grid>
                    </Grid>

                  </MyPATLink>
                )}
              <Grid>
                <Grid item xs={12} className={classes.previewBtn}>
                  <div className="content-preview">

                    {
                      !isArchived ? (statusFlag == "DRAFT"
                        ?
                        <ResponseBasedACL
                          response={_.get(value, 'aclMetaData', {})}
													responseKey='allowedTo'
                          accessType={['EDIT']}
                        >
                          <MyPATLink onClick={() => self.setCourseDetails(value)} to={'/course/detail/' + value._id}>
                            <Button variant="contained" size="small" className={classes.previewButton}>
                              <><Edit />Edit</>
                            </Button>
                          </MyPATLink>
                        </ResponseBasedACL>
                        :
                        allowedTo > 0
                          ?
                          <MyPATLink onClick={() => self.setCourseDetails(value)} to={'/course/detail/' + value._id}>
                            <Button variant="contained" size="small" className={classes.previewButton}>
                              <VisibilityIcon />Preview
                            </Button>
                          </MyPATLink>
                          :
                          <></>)
                        : (
                          <Button variant="contained" size="small" className={classes.previewButton}>
                            <>Draft</>
                          </Button>
                        )
                    }
                    <MyPATLink to="" onClick={(e: any) => onViewDetailsClick(e, value)} displayProp="block" className={classes.viewDetails}> View Detail
											</MyPATLink>
                  </div>
                </Grid>
                <Grid item xs={6} className={statusFlag == 'LIVE' || statusFlag == 'PAST' ? classes.linearProgressBox : 'noneBox'}>
                  {(statusFlag == 'LIVE' || statusFlag == 'PAST') ? <Grid className={statusFlag == 'LIVE' || statusFlag == 'PAST' ? classes.textValue : ''}>
                    <img src={percentage == 100 ? "/assets/img/course/complete.png" : "/assets/img/course/some.png"} alt="USER" className={classes.icon} />
                    <span className={classes.textCaption}>{percentage == 100 ? "Course Completed Successfully" : getNoOfMonths(value.startDate, value.expiryDate)}</span>
                    {/* <LinearProgress classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }} variant="determinate" value={percentage} /> */}
                    <MyPatSliderProgress percentage={percentage} />
                  </Grid> : ""}
                </Grid>
              </Grid>
            </ListItem>
          </Paper>
        </div>
      ) : ''
    });
    return (
      <Grid container style={{ width: "100%" }}>
        <List style={{ width: "100%" }}>
          {ListDiv}
        </List>
      </Grid>
    );
  }
}


const mapStateToProps = (state: any) => ({
  filterGoals: state.courseData.courseData.filterGoals
});


const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    setCourseData: setCourseData
  },
  dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LandingPage));